export const FIELD_MAX_LENGTHS = {
  cpf: 14,
  cpfCaepf: 18,
  cnpj: 18,
  caepf: 19,
  cep: 9,
  phone: 15,
  email: 254,
  password: 128,
  personName: 120,
  socialName: 120,
  companyName: 150,
  street: 150,
  addressNumber: 10,
  complement: 50,
  neighborhood: 80,
  city: 80,
  state: 2,
  policyNumber: 50,
  insurerName: 100,
  inspectionRecordDescription: 500,
  textarea: 10000,
} as const;
